import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    BlockStack,
    Text,
    DropZone,
    LegacyStack,
    Thumbnail,
    Link
} from '@shopify/polaris';
import {
    ImportIcon,
    ExportIcon,
    NoteIcon
} from '@shopify/polaris-icons';
import ModalComponent from '../common/Modal';

const ImportExportMetafields = ({
    isModalOpen,
    handleModalOpen,
    handleDrop,
    handleSubmit,
    isLoading,
    uploadedFile
}) => {
    const navigate = useNavigate();
    return (
        <ModalComponent
            title='Import Metafield Values'
            open={isModalOpen}
            handleModalClose={handleModalOpen}
            primaryAction={{
                icon: ImportIcon,
                content: 'Import Metafields',
                onAction: handleSubmit,
                loading: isLoading
            }}
            secondaryActions={{
                icon: ExportIcon,
                variant: 'plain',
                content: 'Download sample excel file',
                onAction: () => {
                    const link = document.createElement('a');
                    link.href = `${process.env.ADMIN_HOST}/${process.env.DUMMY_CSV_NAME}`;
                    link.download = process.env.DUMMY_CSV_NAME;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }}
        >
            <BlockStack gap="400">
                <Text variant="bodyMd">
                    Upload a CSV file to import metafield values for all product variants.
                </Text>
                <Text variant="bodySm" tone='subdued' as='p'>
                    <strong>Note:</strong> When you export the sample CSV, you'll find our default metafield columns. You only need to update the <strong>metafieldValue</strong>, <strong>productId</strong>, and <strong>variantId</strong> columns. If you have any questions, <Link onClick={() => navigate('/contact-us')}>feel free to ask.</Link>
                </Text>
                <DropZone
                    accept=".csv"
                    errorOverlayText="File type must be .csv"
                    type="file"
                    onDrop={handleDrop}
                >
                    {uploadedFile ? (
                        <LegacyStack alignment="center">
                            <Thumbnail
                                size="small"
                                alt={uploadedFile.name}
                                source={NoteIcon}
                            />
                            <div>
                                {uploadedFile.name}{' '}
                                <Text variant="bodySm" as="p">
                                    {uploadedFile.size} bytes
                                </Text>
                            </div>
                        </LegacyStack>
                    ) : (
                        <DropZone.FileUpload />
                    )}
                </DropZone>
            </BlockStack>
        </ModalComponent>
    );
};

export default ImportExportMetafields;
